<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :rounded="rounded"
            :standout="standout"
            :flat="flat"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            :use-input="false"
            @input="$emit('input', $event)"
        >
            <template v-slot:no-option
            >
                <q-item>
                    <Input
                        :value="searchText"
                        :dark="$attrs.dark"
                        placeholder="Rechercher / Filtrer"
                        class="full-width c-select-filter-input"
                        autofocus
                        :filled="false"
                        dense
                        flat
                        borderless
                        @input="search($event)"
                    />
                </q-item>
                <!-- <q-item>
                    <small>Aucun résultat</small>
                </q-item> -->
            </template>
            <template v-slot:before-options
            >
                <q-item>
                    <Input
                        :value="searchText"
                        :dark="$attrs.dark"
                        placeholder="Rechercher / Filtrer"
                        class="full-width c-select-filter-input"
                        autofocus
                        :filled="false"
                        dense
                        flat
                        borderless
                        @input="search($event)"
                    />
                </q-item>
                <q-list
                    v-if="userGroups"
                >
                    <q-item
                        clickable
                        :key="n"
                        v-for="(userGroup, n) in userGroups"
                        @click="addRecipients(userGroup.values)"
                    >
                        <q-item-section>
                            {{ userGroup.label }}
                        </q-item-section>
                    </q-item>
                    <q-separator inset="item-section" />
                </q-list>
            </template>
            <!-- <template v-slot:before-options
                v-if="this.userGroups"
            >
            </template> -->
            <template v-slot:selected
                v-if="showMax && multiple && $attrs && $attrs.value && $attrs.value.length>parseInt(showMax)"
            >
                <span>{{ $attrs.value.length }} éléments sélectionnés</span>
            </template>
            <template v-slot:selected
                v-else-if="Array.isArray($attrs.value)"
            >
                <span v-if="$attrs.value.length>0">
                    <span class="row inline text-no-wrap" :key="ii" v-for="(item, ii) in $attrs.value">
                        <div>
                            {{ item.name }}
                            <UserProfileInfo :userProfile="item" />
                        </div>
                        <div class="q-mr-xs" v-if="ii < $attrs.value.length - 1">,</div>
                    </span>
                </span>
            </template>
            <template v-slot:selected
                v-else-if="$attrs.value"
            >
                <span class="row inline text-no-wrap">
                    <div>
                        {{ $attrs.value.name }}
                        <UserProfileInfo :userProfile="$attrs.value" />
                    </div>
                </span>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { USERPROFILESSHORT, USERPROFILESSEARCHSHORT } from '@/graphql/user/queries'
    import QSelect from 'quasar'
    import uniqBy from 'lodash/uniqBy'

    export default {
        name: 'UserProfileInput',
        extends: QSelect,
        data(){
            return{
                searchTO: {},
                searchText: ''
            }
        },
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            rounded: {
                type: Boolean,
                default: false
            },
            standout: {
                type: Boolean,
                default: false
            },
            flat: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            showMax: {
                type: [Boolean, Number, String],
                default: false
            },
            userGroups: {
                type: Array,
                default: null
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        mounted(){
            // console.log(this)
        },
        computed: {
            menuItems() {
                if(this.$apollo.queries.userProfiles && !this.$apollo.queries.userProfiles.loading) return this.userProfiles.data
                return new Array();
            }
        },
        methods: {
            addRecipients(recipients=[]){
                if(this.$attrs.value) recipients=[...this.$attrs.value, ...recipients];

                recipients=uniqBy(recipients, 'id');
                this.$emit('input', recipients)
            },
            search(searchText/*, updatefn*/){
                clearTimeout(this.searchTO);
                this.searchText=searchText

                if(searchText && searchText!=""){
                    this.searchTO=setTimeout(function(){
                            if(this.$apollo.queries.userProfilesSearch){
                                delete this.$apollo.queries.userProfilesSearch;
                            }
                            this.$apollo.addSmartQuery('userProfilesSearch', {
                                query: USERPROFILESSEARCHSHORT,
                                fetchPolicy: 'cache-first',
                                error(error){
                                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                                },
                                variables: {
                                    searchText: searchText.trim().split(" ").join("* ")+"*",
                                },
                                manual: true,
                                result ({ data }) {
                                    this.userProfiles = Object.assign({}, data.userProfilesSearch);
                                    // this.$refs.myInput.refresh();
                                }
                            })
                    }.bind(this), 200)
                }else{
                    this.$apollo.queries.userProfiles.refresh()
                    // this.$refs.myInput.refresh();
                }

            }
        },
        apollo: {
            userProfiles: {
                query: USERPROFILESSHORT,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(userProfiles) {
                    userProfiles=userProfiles.userProfiles;

                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)

                    return userProfiles;
                },
                variables() {
                    if(this.variables) return {...this.variables}
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .userProfiles {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>